export default class ImageCropperGenerator {
	// Public:
	constructor(cParams) {
		this._saveParams(cParams);
	}

	compute() {
		var svg = this._svg;
		const k = this._imageScalingFactor;
		var defs = svg.append("defs").attr("id", "defs");
		var setImagePropsFunction = (cP, img, D, k) => this.__setImagePropsFunction(cP, img, D, k);
		const defaultImage = this._defaultImage;

		var func = function (d) {
			if ('img' in d) {
				const url = d.id;
				var cropPattern = defs
					.append("pattern")
					.attr("id", d.id)
					.attr("height", 1)
					.attr("width", 1)
					.attr("x", 0)
					.attr("y", 0);
				const img = d.img || defaultImage;
				const diameter = d.radius * 2;
				setImagePropsFunction(cropPattern, img, diameter, k);

				cropPattern.append("image").attr("xlink:href", img);
				return 'url("#' + url + '")';
			} else {
				return "none";
			}
		};
		this._func = func;
		return this._func;
	}

	// Private:
	_saveParams(cParams) {
		this._svg = cParams.svg;
		this._imageScalingFactor = cParams.imageScalingFactor;
		this._defaultImage = cParams.defaultImage;
	}

	__setImagePropsFunction(cropPattern, url, D, k) {
		var img = new Image();
		img.src = url;
		img.addEventListener("load", function () {
			const w = this.naturalWidth;
			const h = this.naturalHeight;
			const A = Math.max(w, h) / Math.min(w, h);
			const s = D * A * k;
			cropPattern
				.select("image")
				.attr("width", s)
				.attr("height", s)
				.attr("x", (D * (1 - k * A)) / 2)
				.attr("y", (D * (1 - k * A)) / 2);
		});
	}
}